import type { IconSvgObject } from './types';

const ArrowDataTransferDiagonalIcon: IconSvgObject = [
  ["path", { d: "M9 19L20 9V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 4.99997L4 15V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDataTransferDiagonalIcon;
